import React, {Component}  from 'react';
import {connect}           from 'react-redux';
import { Link }                from 'react-router-dom';
import FlashRetornoNulo    from '../../../../container/FlashRetornoNulo';
import {SetExcluirPalavra} from '../../../../actions/atividadesAction';


class PalavraList extends Component {

    excluirPalavras(pal_id) {
        const acao = window.confirm("Deseja Remover?");
        if(acao) {
          this.props.SetExcluirPalavra(pal_id);
        }
    }

    renderPalavras() {
       
        const lista = this.props.all_palavras;
        const acao  = {width : '10%'}

        if (lista.length !==0) {
            return lista.map((elem, i) => {
                return <tr key={i}>
                    <td className="text-center">{elem.ati_pal_pergunta}</td>
                    <td className="text-center" style={acao}>

                          <Link to={`${this.props.menu.desafios.desafiobombaaction}/${this.props.pal_id}/${elem.ati_pal_id}`} className="btn btn-warning btn-xs">
                                  <span className="glyphicon glyphicon-pencil"></span>
                            </Link>
                    </td>
                    <td className="text-center" style={acao}>
                        <button
                            className="btn btn-danger btn-xs"
                            onClick={this
                            .excluirPalavras
                            .bind(this, elem.ati_pal_id)}>
                            <span className="glyphicon glyphicon-remove-sign"></span>
                        </button>
                    </td>
                </tr>
            });

        } else {

            return <tr>
                <td colSpan={3} className="text-center"><FlashRetornoNulo/></td>
            </tr>;
        }
    }

    render() {
       
        return (
            <div>
                <div className="panel panel-azul-claro panel-cinza">
                    <div className="panel-body">                       
                            <table className="table table_panel">
                                <thead>
                                    <tr>
                                        <th className="text-center">Pergunta</th>
                                        <th className="text-center">Editar</th>
                                        <th className="text-center">Excluir</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.renderPalavras()}
                                </tbody>
                            </table>                       
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {

    return {
            menu       : state.configReducer.menu,
            turma        : state.atividadesReducer.turma,
            tipo         : state.atividadesReducer.tipo,
            titulo       : state.atividadesReducer.titulo,
            disciplina   : state.atividadesReducer.disciplina,
            all_palavras : state.atividadesReducer.fetch_all_palavra
          }
}

export default connect(mapStateToProps, {SetExcluirPalavra})(PalavraList);



// WEBPACK FOOTER //
// ./src/components/professor/desafios/bomba/desafios_bomba_list.js